/**
* @author Indeform Ltd
* @copyright Copyright 2020, Indeform Ltd
* @version 20200306
* @description signing status component.
*/


import Component from "../../core/component";

class Status extends Component {
    constructor(ui, elmId, events, params = {}) {
        super(ui, elmId, events, params);

        this.elmForm = document.getElementById(this.params.elmForm);
        this.elmStatusError = document.getElementById(this.params.elmStatusError);
        this.elmStatusCode = document.getElementById(this.params.elmStatusCode);
        this.elmTimer = document.getElementById(this.params.elmTimer);

        if (this.isAttachedToElement() && this.elmForm) {
            this.params.urlStatus = this.elmForm.dataset.urlStatus;
        }

        this.interval = null;
    }


    dispose() {
        super.dispose();

        clearInterval(this.interval);
    }


    init(data) {
        if (!data.hasOwnProperty('control_code')) return;

        this.elmStatusCode.textContent = data.control_code;

        this.initTimeout();
        this.checkStatus();
    }


    initTimeout() {
        let timer = 120;
        this.elmTimer.textContent = timer;

        this.interval = setInterval(() => {
            timer--;
            this.elmTimer.textContent = timer;

            if (timer <= 0) {
                clearInterval(this.interval);
                this.displayError('Request timed out. Please try again later.');
            }
        }, 1000);
    }


    hide() {
        this.elm.classList.add('hidden');
        this.elmStatusError.classList.add('hidden');
    }


    displayError(message) {
        let errors = this.elmForm.querySelectorAll('.error');
        for (let error of errors) {
            if (error.id.length === 0) error.classList.add('hidden');
        }

        this.elmStatusError.textContent = message;
        this.elmStatusError.classList.remove('hidden');
        this.elm.classList.add('hidden');
        this.elmForm.classList.remove('hidden');
    }


    checkStatus() {
        if (!this.params.hasOwnProperty('urlStatus')) {
            console.warn('Status url is not set.');
            return;
        }

        this.core.net.get({url: this.params.urlStatus, data: null, isJson: false})
        .then((data) => {
            try {
                data = JSON.parse(data);
            } catch (e) {
                console.log(e);
                return;
            }

            if (!data.hasOwnProperty('status')) return;

            if (data.status === 'error' && data.hasOwnProperty('message')) {
                this.displayError(data.message);
            } else if (data.status === 'ok') {

                if (data.hasOwnProperty('url')) {
                    window.location.href = data.url;
                } else if (data.hasOwnProperty('locate')) {
                    this.locate(data.locate);
                } else {
                    window.location.href = '/';
                }

            }

            clearInterval(this.interval);
        })
        .catch((e) => console.log(e));
    }
}

export { Status }
export default Status


//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/modules/sign/status.js
// module id = 134
// module chunks = 0